var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 7.00024C6 5.34339 7.34315 4.00024 9 4.00024H16.1716C16.9672 4.00024 17.7303 4.31631 18.2929 4.87892L21.1213 7.70735C21.6839 8.26996 22 9.03302 22 9.82867V21.0002C22 22.6571 20.6569 24.0002 19 24.0002H9C7.34315 24.0002 6 22.6571 6 21.0002V7.00024ZM9 6.00024C8.44772 6.00024 8 6.44796 8 7.00024V21.0002C8 21.5525 8.44772 22.0002 9 22.0002H19C19.5523 22.0002 20 21.5525 20 21.0002V9.82867C20 9.56345 19.8946 9.3091 19.7071 9.12156L16.8787 6.29313C16.6911 6.1056 16.4368 6.00024 16.1716 6.00024H9ZM10 12.0002C10 11.448 10.4477 11.0002 11 11.0002H17C17.5523 11.0002 18 11.448 18 12.0002C18 12.5525 17.5523 13.0002 17 13.0002H11C10.4477 13.0002 10 12.5525 10 12.0002ZM10 16.0002C10 15.4479 10.4477 15.0002 11 15.0002H15C15.5523 15.0002 16 15.4479 16 16.0002C16 16.5525 15.5523 17.0002 15 17.0002H11C10.4477 17.0002 10 16.5525 10 16.0002Z",
    fill: "#0D0D0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/documentIcon.436808966159f6d3cf54a7907a2434d7.svg";
export { ForwardRef as ReactComponent };